// extracted by mini-css-extract-plugin
export default {"image":"ProductItem_image__y14Ss","container":"ProductItem_container__aDtIx","details":"ProductItem_details__Ckzl3","price":"ProductItem_price__kKGOe"};